import React from 'react';
import { Typography, Grid } from '@mui/material';

interface Props {
  title: string;
  buttons?: any;
  xs?: number;
  headlineVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: any;
  itemTitle?: string;
  itemClassName?: any;
}

export function PageHeader({
  title,
  buttons,
  xs,
  headlineVariant,
  className,
  itemTitle,
  itemClassName,
}: Props) {
  return (
    <Grid container spacing={2} className={className}>
      <Grid item flex={1}>
        <Typography variant={headlineVariant || 'h4'}>
          <span className={itemClassName}>{itemTitle} </span>
          <span className={className}>{title}</span>
        </Typography>
      </Grid>
      <Grid item>
        {buttons?.map((item: any, index: number) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
}
